// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eHvBhxy8_2oOA7ylPJAO{padding:0 24px 24px}.fR8pL7swBa5GypJez5cw{flex-direction:column;justify-content:center;height:84px;display:flex}.cu0PgLyOA2gdh2R0rHeg{background:var(--background-neutral-subtle,#f6f7f8);border-radius:6px;margin-top:8px;margin-bottom:8px;padding-right:3px}.ud9Bj3e0ASY8Vm2UxQla{max-height:216px;padding:12px 3px 12px 12px;overflow:auto}.dOENyKdTlkBEwHZfoUTw{padding-top:16px}.Gd8apz6nCY5E226asF4y{color:var(--content-primary-disabled);text-align:left}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `eHvBhxy8_2oOA7ylPJAO`,
	"container": `fR8pL7swBa5GypJez5cw`,
	"wrapText": `cu0PgLyOA2gdh2R0rHeg`,
	"text": `ud9Bj3e0ASY8Vm2UxQla`,
	"actions": `dOENyKdTlkBEwHZfoUTw`,
	"infoText": `Gd8apz6nCY5E226asF4y`
};
export default ___CSS_LOADER_EXPORT___;
